
import { Browse } from "@/models/browse";
import { View } from "@/models/view";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			isOpen: false
		};
	},
	props: {
		browse: {
			type: Object as ()=>Browse,
			required: true
		},
		selectedViews: {
			type: Array as ()=>Number[],
			required: true
		}
	},
	computed: {
		isBrowseSelected():boolean {
			let allSelected = true;
			for (let view of this.browse.Views) {
				if (this.selectedViews.indexOf(view.ID) == -1) {
					allSelected = false;
					break;
				}
			}
			return allSelected;
		},
		angleDirection():string {
			if (this.isOpen) {
				return "angle-down";
			}
			return "angle-up";
		}
	},
	methods: {
		isViewChecked(view:View):boolean {
			return this.selectedViews.indexOf(view.ID) != -1;
		},
		setBrowseChecked(value:boolean) {
			for (let view of this.browse.Views) {
				this.setViewChecked(view, value);
			}
		},
		setViewChecked(view:View, checked:boolean) {
			if (this.isViewChecked(view) == checked) return;
			if (checked) {
				this.selectedViews.push(view.ID);
			}else{
				let i = this.selectedViews.indexOf(view.ID);
				this.selectedViews.splice(i, 1);
			}
		},
		getIconClass(browse:Browse):string{
			return Browse.getIconClassByBrowseId(browse.ID);
		}
	}
});
